module.exports = __webpack_public_path__ + "media/images/browser/safari-d3ef3dba557afa576e7305f7aeb518d8.png";